import { RouteObject, Outlet } from "react-router-dom";
import { ProvideAuth } from "hooks/useAuth";
import AuthedUrqlProvider from "providers/AuthedUrqlProvider";
import { Protected } from "utils/auth/protect";
import RegisterUserData from "./userData";

const InitializeRoutes: RouteObject[] = [
  {
    path: "initialize",
    element: (
      <ProvideAuth>
        <AuthedUrqlProvider>
          <Protected>
            <Outlet />
          </Protected>
        </AuthedUrqlProvider>
      </ProvideAuth>
    ),
    children: [
      { path: "user_data", element: <RegisterUserData /> },
    ],
  },
];

export default InitializeRoutes;
